<template>
  <div id="app" class="flex w-full min-h-screen bg-orange-200">
    <div class="flex flex-col w-full">
      <Header />
      <div class="flex-1 w-full bg-white">
        <div class="w-full py-10 mx-auto md:w-3/4">
          <router-view />
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer
  }
};
</script>
